<template>
    <div class="relative h-full w-full" v-if="camelraceAssets.isReady">
        <video
            class="absolute top-0 h-full w-full object-cover"
            playsinline="true"
            autoplay
            loop
            muted
            preload="auto"
            :src="camelraceAssets.getBlobUrl('backgroundLoop')"
            :type="camelraceAssets.getEncoding('backgroundLoop')"
        />

        <video
            class="absolute top-0 h-full w-full object-cover"
            playsinline="true"
            muted="true"
            preload="auto"
            :src="camelraceAssets.getBlobUrl('gates')"
            :type="camelraceAssets.getEncoding('gates')"
            ref="gates"
        />

        <CamelVideo v-for="camel in camels" :key="camel.color" :camel="camel" />

        <!-- <CamelTurnIndicator /> -->

        <div class="absolute bottom-0 z-3 flex w-full flex-col gap-3 p-5">
            <div class="flex gap-3 px-5">
                <CamelraceCard
                    v-for="camel in camels"
                    :key="camel.color"
                    :color="colors[camel.color]"
                    @click="handleCamelClick(camel)"
                    @click.right.prevent="handleCamelRightClick(camel)"
                    class="h-26 flex-1"
                    hide-bars
                >
                    <CamelraceCard
                        class="absolute top-0 left-1/2 h-10 w-10 -translate-1/2"
                        hide-bars
                        :color="colors[camel.color]"
                    ></CamelraceCard>
                    <div class="absolute top-0 flex h-full w-full flex-col justify-between pt-5">
                        <h2 class="sectionText font-title font-black">{{ camel.section }}</h2>
                        <CamelraceCard
                            class="flex h-10 items-center justify-center"
                            :color="colors[camel.color]"
                        >
                            <b class="font-title mx-auto block text-center text-[.6rem] leading-10">
                                {{ camel.dartsThisTurn }}x
                            </b>
                        </CamelraceCard>
                    </div>
                </CamelraceCard>
            </div>
            <div class="flex gap-2">
                <CamelraceCard
                    class="font-title h-12 flex-1 text-center text-sm leading-12 font-bold uppercase"
                    @click="lockScore"
                >
                    {{ $t('killer.lock_in') }}
                </CamelraceCard>
                <CamelraceCard class="flex h-12 w-12" @click="quitMatch">
                    <div class="flex h-full w-full items-center justify-center">
                        <svg
                            width="15"
                            height="10"
                            viewBox="0 0 15 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M5.44141 0.720703L1.44141 4.57785M1.44141 4.57785L5.44141 8.43499M1.44141 4.57785L13.4414 4.57764V9.72049"
                                stroke="white"
                                stroke-width="2"
                            />
                        </svg>
                    </div>
                </CamelraceCard>
            </div>
        </div>
    </div>
</template>

<script>
import { useMatchStore } from '@/stores/match.js'
import { camelraceAssets } from '@/stores/camelraceAssets'
import CamelVideo from '@/components/games/camelrace/CamelVideo.vue'
import CamelraceCard from '@/components/games/camelrace/CamelraceCard.vue'

export default {
    name: 'CamelraceGame',
    components: {
        CamelVideo,
        CamelraceCard,
    },
    data() {
        return {
            camels: [
                {
                    color: 'red',
                    hexColor: '#E50328',
                    profile: null,
                    step: 0,
                    section: 11,
                    dartsThisTurn: 0,
                    start: { x: 25.6, y: 68.6 },
                    end: { x: 33, y: 7 },
                    stepSizes: [1, 1.6, 1.5, 1.45, 1.4, 1.35, 1.3, 1.25, 1.2, 1.17, 1.13],
                    transforms: {
                        rotateX: 40,
                        rotateZ: 3,
                    },
                },
                {
                    color: 'blue',
                    hexColor: '#12A9D4',
                    profile: null,
                    step: 0,
                    section: 9,
                    dartsThisTurn: 0,
                    start: { x: 41.9, y: 68.6 },
                    end: { x: 44.4, y: 7 },
                    stepSizes: [1, 1.6, 1.5, 1.45, 1.4, 1.35, 1.3, 1.25, 1.2, 1.17, 1.13],
                    transforms: {
                        rotateX: 40,
                    },
                },
                {
                    color: 'green',
                    hexColor: '#72A911',
                    profile: null,
                    step: 0,
                    section: 20,
                    dartsThisTurn: 0,
                    start: { x: 58.2, y: 68.6 },
                    end: { x: 55.5, y: 7 },
                    stepSizes: [1, 1.6, 1.5, 1.45, 1.4, 1.35, 1.3, 1.25, 1.2, 1.17, 1.13],
                    transforms: {
                        rotateX: 40,
                    },
                },
                {
                    color: 'purple',
                    hexColor: '#B30ED3',
                    profile: null,
                    step: 0,
                    section: 3,
                    dartsThisTurn: 0,
                    start: { x: 74.3, y: 68.6 },
                    end: { x: 66.5, y: 7 },
                    stepSizes: [1, 1.6, 1.5, 1.45, 1.4, 1.35, 1.3, 1.25, 1.2, 1.17, 1.13],
                    transforms: {
                        rotateX: 50,
                        rotateZ: -2,
                    },
                },
            ],
            started: false,
            colors: {
                red: '#E50328',
                blue: '#12A9D4',
                green: '#72A911',
                purple: '#B30ED3',
            },
        }
    },
    computed: {
        matchStore() {
            return useMatchStore()
        },
        profiles() {
            return this.matchStore.getProfiles
        },
        currentPlayer() {
            return this.matchStore.getCurrentPlayer
        },
        matchData() {
            return this.matchStore.getMatchData
        },
        camelraceAssets() {
            return camelraceAssets()
        },
    },
    methods: {
        handleCamelClick(camel) {
            camel.dartsThisTurn++
            this.startMatch()
            camel.step++
        },
        handleCamelRightClick(camel) {
            camel.step--
            camel.dartsThisTurn--
        },
        quitMatch() {
            console.log('Quitting match, clearing match data')
            this.matchStore.clearMatch()
            this.$router.push({ name: 'games' })
        },
        startMatch() {
            if (this.started) return
            this.started = true

            if (this.$refs.gates && this.$refs.gates.paused) {
                this.$refs.gates.play()
            }
        },
        lockScore() {
            let throws = []

            this.camels.forEach((camel) => {
                while (camel.dartsThisTurn > 0) {
                    if (camel.dartsThisTurn >= 3) {
                        throws.push({ multiplier: 3, score: camel.section })
                        camel.dartsThisTurn -= 3
                    } else if (camel.dartsThisTurn === 2) {
                        throws.push({ multiplier: 2, score: camel.section })
                        camel.dartsThisTurn -= 2
                    } else if (camel.dartsThisTurn === 1) {
                        throws.push({ multiplier: 1, score: camel.section })
                        camel.dartsThisTurn -= 1
                    }
                }
            })

            while (throws.length < 3) {
                throws.push({ multiplier: 0, score: 0 })
            }

            console.log(throws)
            this.currentTurn = 0
        },
    },
    mounted() {
        this.camelraceAssets.preloadAssets()

        // The router skips screen_view for game routes so the event can carry the game type.
        const matchId = this.$route.params.matchId ?? this.matchStore.setup?.id
        this.$analytics.trackScreen('Game On - Game', {
            game_type: 'Camelrace',
            game_context: this.matchStore.isRemotePlay ? 'online' : 'local',
            // Game routes skip trackPageView, so match_id has to be attached here for the
            // in-game events to inherit it as a sticky param.
            ...(matchId ? { match_id: String(matchId) } : {}),
            route_name: this.$route.name,
            path: this.$route.fullPath,
        })
    },
}
</script>

<style lang="scss"></style>
